import { ExitingPersistence, SlideIn } from '@atlaskit/motion';
import * as React from 'react';
import {
  dismissNotificationWithId,
  dismissOldestNotification,
  notificationsSelectors,
} from '../../state/src/notifications-slice';
import Notification from './notification';
import '../../assets/css/notifications.scss';
import { useSelector, useDispatch } from 'react-redux';
import { NotificationFlag } from '../../notification-flag';

const ESCAPE_KEY = 27;

export enum NotificationTypes {
  LEGACY,
  FLAG,
}

const Notifications = () => {
  const dispatch = useDispatch();

  const onCloseClick = (id: string) => dispatch(dismissNotificationWithId(id));
  const notifications = useSelector(notificationsSelectors.getNotifications);

  const onKeyUp = React.useCallback(
    (event: KeyboardEvent) => {
      const key = event.which || event.keyCode;
      if (key === ESCAPE_KEY && notifications.length > 0) {
        dispatch(dismissOldestNotification());
      }
    },
    [dispatch, notifications.length]
  );

  React.useEffect(() => {
    window.addEventListener('keyup', onKeyUp);

    return () => {
      window.removeEventListener('keyup', onKeyUp);
    };
  }, [onKeyUp]);

  return (
    <ExitingPersistence>
      <div className="notifications" data-testid="notifications">
        {notifications.map((notificationOptions: any) => {
          if (notificationOptions.version === NotificationTypes.FLAG) {
            return <NotificationFlag onCloseClick={onCloseClick} {...notificationOptions} />;
          }
          return (
            <SlideIn enterFrom={'top'} key={'notification' + notificationOptions.id}>
              {({ className, ...otherProps }) => (
                <div className={`notification ${className}`} data-testid={`${notificationOptions.id}`} {...otherProps}>
                  <Notification onCloseClick={onCloseClick} {...notificationOptions} />
                </div>
              )}
            </SlideIn>
          );
        })}
      </div>
    </ExitingPersistence>
  );
};

export default Notifications;
